// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"b2d65479","247":"4c03b331","627":"95b8637d","768":"6a427f24","806":"9850a2a6","834":"aaef8458","923":"a9176929","938":"c12e7eac"}[chunkId] + ".chunk.js";
};